<template>
  <div class="statisticalReports">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span
              v-if="
                item.field === 'minQuantity' ||
                item.field === 'maxQuantity' ||
                item.field === 'registAsset'
              "
              >{{ Number(scope.row[item.field]).toFixed(2) }}</span
            >
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/tradingQuota/applicationQuota.js';
  // import COOPERATION_API from '@/api/masterData/cooperation';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'statisticalReports',
    data() {
      return {
        load: false,
        query: {
          controlAreaCode: null, //事业部门
          mdPartnerType: null, //合作伙伴类型
          onlyShowParent: null, //只显示母公司额度
          partnerNo: null, //合作伙伴名称
          creditCode: null, //信用账户号
        },
        columnList: [],
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { type: 'seq', visible: true, width: '50', fixed: 'left', title: 'table.index' },
          {
            field: 'controlAreaCode',
            title: 'maintenanceManage.table.divisionCode',
            visible: true,
          },
          {
            field: 'controlAreaName',
            title: 'maintenanceManage.table.divisionName',
            visible: true,
          },
          {
            field: 'partnerTypeName',
            title: 'maintenanceManage.search.partnersType',
            visible: true,
          },
          {
            field: 'creditLevelName',
            title: 'maintenanceManage.search.creditRating',
            visible: true,
          },
          { field: 'partnerNo', title: 'maintenanceManage.table.partnersCode', visible: true },
          { field: 'partnerName', title: 'maintenanceManage.search.partnersName', visible: true },
          { field: 'registDate', title: 'maintenanceManage.table.setUpDate', visible: true },
          {
            field: 'registAsset',
            title: 'maintenanceManage.table.registeredCapital',
            visible: true,
          },
          {
            field: 'creditAccount',
            title: 'maintenanceManage.table.creditAccounts',
            visible: true,
          },
          {
            field: 'creditAccountDesc',
            title: 'maintenanceManage.table.creditAccountsPlaceholder',
            visible: true,
          },
          { field: 'validStart', title: 'maintenanceManage.search.validityStart', visible: true },
          { field: 'validEnd', title: 'maintenanceManage.search.validityEnd', visible: true },
          {
            field: 'minQuantity',
            title: 'maintenanceManage.table.unilateralTradeStart',
            visible: true,
          },
          {
            field: 'maxQuantity',
            title: 'maintenanceManage.table.unilateralTradeEnd',
            visible: true,
          },
          { field: 'quantityUnitName', title: 'maintenanceManage.table.unit', visible: true },
          { field: 'gmtCreate', title: 'maintenanceManage.table.creationDate', visible: true },
          {
            field: 'quantityCreatePersonName',
            title: 'maintenanceManage.table.founder',
            visible: true,
          },
          { field: 'mark', title: 'maintenanceManage.table.mark', visible: true },
          {
            field: 'availableQuantity',
            title: 'maintenanceManage.table.availableQuantity',
            visible: true,
          },
          {
            field: 'undeliveryQuantity',
            title: 'maintenanceManage.table.undeliveryQuantity',
            visible: true,
          },
          {
            field: 'uninboundQuantity',
            title: 'maintenanceManage.table.uninboundQuantity',
            visible: true,
          },
        ],
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        partnerTypeList: [],
        businessDepartmentList: [], //事业部门下拉列表
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'controlAreaCode',
            name: this.$t('maintenanceManage.search.businessDepartment'),
            placeholder: this.$t('maintenanceManage.search.businessDepartment'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_TREE,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
              currentStatus: '0',
            },
            clearable: false,
            normalizerFlag: true,
          },
          {
            prop: 'mdPartnerType',
            name: this.$t('maintenanceManage.search.partnersType'),
            type: 'select',
            clearabled: true,
            options: this.partnerTypeList,
          },
          {
            prop: 'onlyShowParent',
            name: this.$t('maintenanceManage.search.isParentCompany'),
            type: 'select',
            clearabled: true,
            options: [
              {
                value: '0',
                label: this.$t('maintenanceManage.search.isParentCompanyOne'),
              },
              {
                value: '1',
                label: this.$t('maintenanceManage.search.isParentCompanyTwo'),
              },
            ],
          },
          {
            prop: 'partnerZhName',
            name: this.$t('cooperation.label.partnerZhName'),
            type: 'searchTableSpec',
            searchType: 'partner',
            width: '800',
            isMultiple: true,
            placeholder: this.$t('cooperation.placeholder.partnerZhName'),
          },
          {
            prop: 'creditAccount',
            name: this.$t('maintenanceManage.search.creditAccounts'),
            type: 'input',
            clearabled: true,
            placeholder: this.$t('maintenanceManage.search.creditAccountsPlaceholder'),
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      this.getButtonList();
      this.getDictList();
      this.getData();
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      // 获取字典表数据
      getDictList() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 合作伙伴类型
        this.$axios.post(API.DATA_DICT, { dictType: 'partner_type', tenantCode }).then((res) => {
          if (res.data.code === 0) {
            this.partnerTypeList = res.data.data; // 下拉
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
        //业务部门
        const query = {
          tenantCode: this.userInfo.tenantCode,
          adminFlag: this.userInfo.adminFlag,
        };
        this.$axios.post(DataBaseAPI.LIST_COMPANY_API, query).then((res) => {
          if (0 == res.data.code) {
            this.businessDepartmentList = res.data.data;
            this.getSelectedNode(this.businessDepartmentList, this.businessDepartmentList);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //获取数据
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = {
          ...this.query,
          pageNum,
          pageSize,
        };
        if (this.query.partnerZhName && this.query.partnerZhName[0].partnerCode) {
          // params.partnerCode = this.query.partnerZhName[0].partnerCode;
          // params.partnerName = params.partnerZhName[0].partnerZhName;
          params.partnerNo =
            params.partnerZhName[0].allPartnerCode || params.partnerZhName[0].partnerCode; //客户
        }
        delete params.partnerZhName;
        this.load = true;
        this.$axios.post(API.LIST_API, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'export') {
          this.handleExport();
        }
      },
      handleExport() {
        const params = {
          ids: this.multipleSelection.map((item) => {
            return item.id;
          }),
          ...this.query,
        };
        this.$axios.post(API.EXPORT_SUMMARY_API, params).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/applicationQuota/analysisReport',
          name: 'analysisReport',
          meta: {
            keepAlive: true,
            title: this.$t('maintenanceManage.router.analysisReport'),
          },
          query: { id: value.row.id },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
